import {
  ItemTypeEnum,
  ProductTypeEnum,
  getBaseProductSchema,
  orthoModelItemSchema,
  type OrthoModelProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type OrthoModelStepKey = typeof StepKeysEnum.arch;

/**
 * `min(1)` and not `length(1)`: a retention wire created by V1 on both arches holds two
 * items on a single product, and must stay readable and editable from V2.
 */
const orthoModelArchesSchema = z.object({
  items: z.array(orthoModelItemSchema).min(1),
});

export const OrthoModelWorkflowConfiguration: ProductWorkflowConfiguration<
  OrthoModelProduct,
  OrthoModelStepKey
> = {
  productType: ProductTypeEnum.orthoModel,
  itemType: ItemTypeEnum.orthoModel,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: orthoModelItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    return orthoModelArchesSchema.safeParse(product).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
